// Columnas para el formulario (crear/editar)
export const laundriesFormColumns = [
  {
    id: 'estado', label: 'Estado', type: 'select', sortable: true, required: true, options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ]
  },
  { id: 'nombre', label: 'Nombre Centro de lavado', type: 'text', sortable: true, required: true },
  { id: 'ciudad', label: 'Ciudad', type: 'text', sortable: true, required: true },
  { id: 'direccion', label: 'Dirección', type: 'text', sortable: true, required: true },
  { id: 'supervisor', label: 'Supervisor', type: 'text', sortable: true, required: true },
  { id: 'telefono', label: 'Teléfono', type: 'text', sortable: true, required: true },
  { id: 'asesor', label: 'Asesor', type: 'text', sortable: true, required: false },
  {
    id: 'locationLavanti', label: 'Integración Lavanti', type: 'boolean', sortable: true, required: false,
    formType: 'select',
    options: [
      { value: true, label: 'Sí' },
      { value: false, label: 'No' },
    ]
  },
  { id: 'correosReporte', label: 'Correos para Reportes (separados por coma)', type: 'text', sortable: true, required: false },
  {
    id: 'porcentajeHumedad',
    label: '% Humedad (Ropa sucia)',
    type: 'number',
    sortable: true,
    required: false,
    min: 0,
    max: 100,
    step: 0.01,
    // Tooltip explicativo en el formulario (DynamicFormModal)
    helperText: 'Porcentaje a descontar del peso húmedo al registrar ropa sucia. Ej: 10% → 100kg mojados quedan como 90kg en el sistema. 0 = sin descuento.',
  },
];

// Columnas para la tabla (incluye columnas adicionales de solo lectura)
export const laundriesColumns = [
  ...laundriesFormColumns,
  { 
    id: 'funcionalidadesHabilitadas', 
    label: 'Funcionalidades Habilitadas', 
    type: 'array', 
    sortable: false, 
    required: false,
    render: (row) => {
      const count = row.funcionalidadesHabilitadas?.length || 0;
      return count > 0 ? `${count} habilitadas` : 'No configuradas';
    }
  },
  {
    id: 'actions',
    label: 'Acciones',
    type: 'actions',
    actions: [
      { key: 'configure', icon: 'Settings', tooltip: 'Configurar Funcionalidades', className: 'text-blue-600 hover:text-blue-800' },
      { key: 'indicators', icon: 'TrendingUp', tooltip: 'Configurar Indicadores', className: 'text-purple-600 hover:text-purple-800' },
      { key: 'edit', icon: 'Edit', tooltip: 'Editar' },
      { key: 'delete', icon: 'Trash2', tooltip: 'Eliminar', className: 'text-red-600 hover:text-red-800' },
    ],
  },
];

export const columnsExcel = laundriesFormColumns.map(col => ({ key: col.id, header: col.label }));
